import { Alert, Badge, Card, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';
import { handleApiExceptions } from '../../../../app_methods';
import { Text4 } from '../../../../styles';
import { TRANSFER_STATUS_TYPES } from '../../../../constants';
import { EaseDrawer } from '../../../../libs/EaseDrawer';

const PaymentDetailsDrawer = (props) => {
    const invoice = props.vendorInvoice || {};
    const vendor = invoice.vendor || {};
    const [attempts, setAttempts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPaymentAttempts = async () => {
        setIsLoading(true);
        const response = await invoice.fetchAttempts();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setAttempts(response.data.attempts);
        setIsLoading(false);
    };

    const renderCardTitle = (attempt) => {
        return (
            <div className="mb-2 d-flex justify-content-between">
                <div>
                    <Badge
                        size="large"
                        color={attempt ? attempt.status ? TRANSFER_STATUS_TYPES[attempt.status].color : 'green' : ''}
                        text={<Text4 strong>{attempt ? attempt.status ? TRANSFER_STATUS_TYPES[attempt.status].label : 'Success' : '---'}</Text4>}
                    />
                </div>
                <div className="d-flex align-items-center justify-content-end">
                    <Text4 type="secondary">{attempt.created_at && moment(attempt.created_at).format("LLL")}</Text4>
                </div>
            </div>
        )
    };

    const renderCardDetails = (attempt) => {
        return (
            <>
                {
                    attempt.payment_mode ?
                        <>
                            <div className="row">
                                <div className="col-6">
                                    <Text4 type="secondary" style={{fontStyle: "italic"}} strong>PAYMENT MODE:</Text4>
                                </div>
                                <div className="col-6">
                                    <Text4 style={{textTransform: "uppercase",fontStyle: "italic"}}>{attempt.payment_mode}</Text4>
                                </div>
                            </div>
                        </>
                        : null
                }
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary Name:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.vendor_account_name}</Text4>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary Account No.:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.vendor_account_number}</Text4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary IFSC Code:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.vendor_account_ifsc}</Text4>
                    </div>
                </div>

                {
                    (attempt.status == "failure" || attempt.status == "success") && attempt.utr ?
                        <div className="row">
                            <div className="col-6">
                                <Text4 type="secondary" strong>UTR: </Text4>
                            </div>
                            <div className="col-6">
                                <Text4>{attempt.utr}</Text4>
                            </div>
                        </div>
                        :
                        null
                }
            </>
        )
    }

    return (
        <EaseDrawer
            className="payment-attempts-drawer-wrapper"
            visible={props.visible}
            onOpen={fetchPaymentAttempts}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={500}
        >
            <Typography.Title className="mt-4 mb-4" level={4}>Payment Details</Typography.Title>
            {
                isLoading ?
                    <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                        <Spin className="mt-4" tip="Loading..." spinning={isLoading} />
                    </div>
                    :
                    attempts.length ?
                        attempts.map((attempt, index) => {
                            return (
                                <Card
                                    className="mb-2"
                                    size="small"
                                    title={false}
                                >
                                    {renderCardTitle(attempt)}
                                    {renderCardDetails(attempt)}
                                </Card>
                            );
                        })
                        :
                        <Alert
                            message="Nothing to show"
                            description="No payment attempts have been made so far."
                            type="info"
                            showIcon
                        />
            }
        </EaseDrawer>
    )
};

export { PaymentDetailsDrawer };